import React, { useEffect, useState } from 'react';
import PortfolioCard from './PortfolioCard';
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import "animate.css"


function Portfolio({ sites }) {
    const [category, setCategory] = useState('Todas');
    const [activeTab, setActiveTab] = useState(0);
    let categories = [
        { id: 0, name: 'Todas', speciality: 'bundle.speciality0' },
        // { id: 1, name: 'Bebidas', speciality: 'bundle.speciality1' },
        // { id: 2, name: 'Casas e Móveis', speciality: 'bundle.speciality2' },
        // { id: 3, name: 'Cosméticos', speciality: 'bundle.speciality3' },
        // { id: 4, name: 'Entretenimento', speciality: 'bundle.speciality4' },
        // { id: 5, name: 'Games', speciality: 'bundle.speciality5' },
        // { id: 6, name: 'Infantil/Bebês', speciality: 'bundle.speciality6' },
        // { id: 7, name: 'Informática', speciality: 'bundle.speciality7' },
        // { id: 8, name: 'Moda e Acessórios', speciality: 'bundle.speciality8' },
        // { id: 9, name: 'Perfumes', speciality: 'bundle.speciality9' },
        // { id: 10, name: 'Pet', speciality: 'bundle.speciality10' },
        // { id: 11, name: 'Saúde', speciality: 'bundle.speciality11' },
        // { id: 12, name: 'Sexshop', speciality: 'bundle.speciality12' },
        // { id: 14, name: 'Suplementos', speciality: 'bundle.speciality14' },
        // { id: 13, name: 'Outros', speciality: 'bundle.speciality13' }
    ];

    const updatedCategories = sites.reduce((acc, site) => {
        if (site.categories) {
            site.categories.forEach((category) => {
                if (!acc.some((cat) => cat.name === category)) {
                    acc.push({ id: acc.length + 1, name: category, speciality: 'bundle.speciality' });
                }
            });
        }
        return acc;
    }, []);

    categories = [...categories, ...updatedCategories];


    const filterProducts = () => {
        if (category !== 'Todas') {
            return sites.sort(() => 0.5 - Math.random()).filter((product) => product.categories.includes(category)).slice(0, 6);
        }
        return sites.slice(0, 6);
    }

    const handleCategory = (_category) => {
        setCategory(_category);
    }

    useEffect(() => { }, [activeTab, category]);

    return (
        <div>
            <section id="portfolio" className="br-portfolio padding-tb-80">
                <div className="container">
                    <div className="section-title">
                        <h2>Lojas <span>Incríveis</span></h2>
                        <span className="ligh-title">LOJAS</span>
                    </div>
                    <div className="row m-b-minus-24px">
                        <div className="portfolio-content">
                            <div>
                                <div className="row">
                                    <Tabs selectedIndex={activeTab} onSelect={(index) => setActiveTab(index)}>
                                        <div className="col-sm-12">
                                            <div className="portfolio-tabs">
                                                <TabList>
                                                    {categories.map((_category, index) => (
                                                        <Tab onClick={() => handleCategory(_category.name)} key={index} className="filter" data-filter="Todas">{_category.name} | </Tab>
                                                    ))}
                                                </TabList>
                                            </div>
                                        </div>
                                        {categories.map((_category, index) => (
                                            <TabPanel key={index}>

                                                <div style={{ transform: 'scale(1)', transition: 'transform 0.3s ease-out' }} className="col-md-12 col-sm-12">
                                                    <div className="portfolio-content-items">
                                                        <div className="row m-b-minus-30px">
                                                            {filterProducts().map((data, i) => (
                                                                <PortfolioCard key={i} data={data} selectedCategory={category.name} />
                                                            ))}
                                                        </div>
                                                    </div>
                                                </div>

                                            </TabPanel>
                                        ))}
                                    </Tabs>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default Portfolio;
